import type { ProductsData } from '@/app/api/search/products/createProductsData.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation';
import type { ControlProps } from '@/app/components/search/components/Form';
import FilterContainer from '../FilterContainer';
import getRadioContainer from './getRadioContainer';
import { getLocalStorageObject, LOCAL_STORAGE_KEY } from '../../../../utils/localStorage';
import { hasAirportsOnly } from '../../../../utils/productsResponse';
import type { CommonProps } from './CommonProps';

const getDestinationAirportField = ({
  isWaiting,
  productsData,
  t,
  searchParams,
  commonProps,
}: {
  isWaiting: boolean;
  productsData: ProductsData;
  t: TranslationFunction;
  searchParams: SearchParams;
  commonProps: CommonProps;
}): ControlProps => {
  let airports = productsData?.transport?.airports;
  const { isMobile, isSidebar, isHorizontal } = commonProps;
  if (!airports) {
    airports = getLocalStorageObject(LOCAL_STORAGE_KEY.PREFILTER_DESTINATION_AIRPORT);
  }
  const value = searchParams[URLParameters.PRE_FILTER_DESTINATION_AIRPORT]
    ? searchParams[URLParameters.PRE_FILTER_DESTINATION_AIRPORT]
    : 0;

  return getRadioContainer({
    fieldName: URLParameters.PRE_FILTER_DESTINATION_AIRPORT,
    containerTitle: hasAirportsOnly(productsData)
      ? t('vacation.oss.filters.destination_airport.title')
      : t('vacation.oss.filters.destination_airport_station.title'),
    containerName: FilterContainer.DestinationAirportContainer,
    options: [
      {
        value: 0,
        label: t('vacation.oss.filters.destination_airport.any'),
        disabled: isWaiting,
      },
      ...(Array.isArray(airports)
        ? airports.map((x) => ({
            value: x.iata,
            label: `${x.cityName} (${x.iata}) ${x.name}`,
            disabled: isWaiting,
          }))
        : []),
    ],
    value,
    isMobile,
    isSidebar,
    isHorizontal,
  });
};

export default getDestinationAirportField;
